import { render } from "./ProgressbarPractice.vue?vue&type=template&id=62164c4e&scoped=true"
import script from "./ProgressbarPractice.vue?vue&type=script&lang=js"
export * from "./ProgressbarPractice.vue?vue&type=script&lang=js"

import "@/css/components/progressbar-practice.css?vue&type=style&index=0&id=62164c4e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62164c4e"]])

export default __exports__